import { Controller } from "@hotwired/stimulus"

// The add-wine form's "Auto-fill from name": asks the server to identify
// the wine from the producer and name typed so far and fills in the fields
// still blank. Never overwrites what the user typed or the label read, and
// leaves the type alone once the user has picked one. Ported from the
// legacy WineForm.tsx.
const FILLED = "Filled in what we know — double-check before saving."
const UNSURE = "We're not sure about this one — please check every field."
const FAILED = "Couldn't auto-fill — enter the details yourself."

export default class extends Controller {
  static targets = ["producer", "wineName", "region", "appellation", "grapes", "wineType", "autofill", "note", "submit"]
  static values = { parseUrl: String }

  connect() {
    this.typeTouched = false
    this.looking = false
    this.refresh()
  }

  refresh() {
    this.autofillTarget.disabled = this.looking || !(this.producerTarget.value.trim() || this.wineNameTarget.value.trim())
  }

  touchType() {
    this.typeTouched = true
  }

  async autofill() {
    const producer = this.producerTarget.value.trim()
    const wineName = this.wineNameTarget.value.trim()
    if (this.looking || (!producer && !wineName)) return
    this.looking = true
    this.autofillTarget.textContent = "Looking up…"
    this.refresh()
    this.noteTarget.hidden = true
    try {
      const headers = { "Content-Type": "application/json", Accept: "application/json" }
      const token = document.querySelector('meta[name="csrf-token"]')
      if (token) headers["X-CSRF-Token"] = token.content
      const response = await fetch(this.parseUrlValue, {
        method: "POST",
        headers,
        credentials: "same-origin",
        body: JSON.stringify({ producer, wineName })
      })
      if (!response.ok) throw new Error(`parse failed (${response.status})`)
      const r = await response.json()
      this.fill(r)
      this.say(r.recognized && r.confidence !== "low" ? FILLED : UNSURE)
    } catch (err) {
      this.say(FAILED)
    } finally {
      this.looking = false
      this.autofillTarget.textContent = "✨ Auto-fill from name"
      this.refresh()
    }
  }

  // Only blanks are filled.
  fill(r) {
    if (!this.producerTarget.value.trim() && r.producer) this.producerTarget.value = r.producer
    if (!this.wineNameTarget.value.trim() && r.wineName) this.wineNameTarget.value = r.wineName
    if (!this.regionTarget.value.trim() && r.region) this.regionTarget.value = r.region
    if (!this.appellationTarget.value.trim() && r.appellation) this.appellationTarget.value = r.appellation
    if (!this.grapesTarget.value.trim() && Array.isArray(r.grapeVarieties) && r.grapeVarieties.length) {
      this.grapesTarget.value = r.grapeVarieties.join(", ")
    }
    if (!this.typeTouched && r.wineType) {
      const radio = this.wineTypeTargets.find((input) => input.value === r.wineType)
      if (radio) radio.checked = true
    }
  }

  say(message) {
    this.noteTarget.textContent = message
    this.noteTarget.hidden = false
  }
}
